import {
  MessageResponseDto,
  GetVisitDto,
  VisitControllerGet200Response,
  VisitApiFp,
  DeleteVisitDto,
  CreateVisitBaseDto,
  EditVisitBaseDto,
  CreateAttachmentVisitBaseDto,
  GetAttachmentVisitDto,
  VisitControllerGetAttachment200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseVisitModel = VisitControllerGet200Response;
export type GetResponseAttachmentVisitModel = VisitControllerGetAttachment200Response;

export type GetAttachmentVisitModel = GetAttachmentVisitDto;
export type GetVisitModel = GetVisitDto;
export type MutateResponseVisitModel = MessageResponseDto;
export type CreateVisitModel = CreateVisitBaseDto;
export type UpdateVisitModel = EditVisitBaseDto;
export type DeleteVisitModel = DeleteVisitDto;
export type AttachFileVisitModel = CreateAttachmentVisitBaseDto;

export interface CreateVisitModelExtension {
  visit: CreateVisitModel;
  file: File;
}

export interface UpdateVisitModelExtension {
  visit: UpdateVisitModel;
  file: File;
}

export interface AttachFileVisitModelExtension {
  attachment: AttachFileVisitModel;
  file: File[];
}

export const apiVisitFp = VisitApiFp(apiConfig);
export const getVisitController = apiVisitFp.visitControllerGet;
export const createVisitController = apiVisitFp.visitControllerCreate;
export const updateVisitController = apiVisitFp.visitControllerEdit;
export const deleteVisitController = apiVisitFp.visitControllerDelete;
export const attachFileVisitController = apiVisitFp.visitControllerAttachFile;
export const getAttachmentVisitController =
  apiVisitFp.visitControllerGetAttachment;

export const QueryKeyVisit = QueryKey.Visit;
export const QueryKeyAttachmentVisit = QueryKey.AttachmentVisit;
